import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exportToPDF from '../util/exportToPDF';

import { showModal } from '../../../../actions/ModalActions';

import FeatureFlags from '../../../../util/featureFlags';
import { downloadXLSX, makeChartList } from '../util/seatingChartUtils';

import './ActionsBar.styles.less';

const ActionsBar = ({
  couple,
  event,
  guestsByID,
  onAddTable,
  onDeleteChart,
  orderedTableUUIDs,
  seatingChart,
  seatsByUUID,
  tableUUIDs,
  tablesByUUID,
}) => {
  const tableCount = tableUUIDs.length;

  const useNewPDF = FeatureFlags.get('newSeatingPDF');
  const onDownloadClick = () => exportToPDF(couple, seatingChart);

  const mealsByID = event ? event.meal_options
    .reduce((acc, option) => ({ ...acc, [option.id]: option.name }), {})
    : null;

  const chartList = makeChartList(guestsByID, mealsByID, orderedTableUUIDs, seatsByUUID, tablesByUUID);
  const { name } = seatingChart;
  const fileName = (name)
    ? `${name.replace(/ /g, '_')}_Seating_Chart`
    : 'seating_chart';

  return (
    <section className="sc__actions-bar">
      <div className="sc__actions-bar__button-group">
        <button
          className="sc__actions-bar__button"
          onClick={() => onAddTable(tableCount)}
        >
          <i aria-hidden className="zolaicon zolaicon-plus" />
          <span className="sc__actions-bar__label">Add table</span>
        </button>
      </div>
      <div className="sc__actions-bar__button-group">
        {useNewPDF &&
          <button
            onClick={() => downloadXLSX(fileName, chartList)}
            className="sc__actions-bar__button sc__actions-bar__button--secondary"
            disabled={tableCount === 0}
          >
            <i aria-hidden className="zolaicon zolaicon-download-file" />
            <span className="sc__actions-bar__label">Download</span>
          </button>
        }
        {!useNewPDF &&
          <button
            className="sc__actions-bar__button sc__actions-bar__button--secondary"
            onClick={onDownloadClick}
            disabled={tableCount === 0}
          >
            <i aria-hidden className="zolaicon zolaicon-download-file" />
            <span className="sc__actions-bar__label">Download</span>
          </button>
        }
      </div>
      <div className="sc__actions-bar__button-group">
        <button
          aria-label="Delete chart"
          className="sc__actions-bar__button sc__actions-bar__button--secondary"
          onClick={() => onDeleteChart(seatingChart.uuid)}
        >
          <i aria-hidden className="zolaicon zolaicon-trash" />
        </button>
      </div>
    </section>
  );
};

ActionsBar.propTypes = {
  seatingChart: PropTypes.shape({
    uuid: PropTypes.string
  }),
  couple: PropTypes.shape({
    primary: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      display_name: PropTypes.string,
      seat_uuid: PropTypes.string,
      table_uuid: PropTypes.string,
      couple_role: PropTypes.string,
      isVisible: PropTypes.bool,
    }),
    partner: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      display_name: PropTypes.string,
      seat_uuid: PropTypes.string,
      table_uuid: PropTypes.string,
      couple_role: PropTypes.string,
      isVisible: PropTypes.bool,
    }),
  }),
  event: PropTypes.shape({ meal_options: PropTypes.array }),
  guestsByID: PropTypes.objectOf(PropTypes.any),
  onAddTable: PropTypes.func.isRequired,
  onDeleteChart: PropTypes.func.isRequired,
  orderedTableUUIDs: PropTypes.arrayOf(PropTypes.string),
  seatsByUUID: PropTypes.objectOf(PropTypes.any),
  tableUUIDs: PropTypes.arrayOf(PropTypes.string),
  tablesByUUID: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = state => ({
  couple: state.guestRail.couple,
  guestsByID: state.seatingChart.guestsByID,
  event: state.events.events.byId[state.seatingChart.seatingChart.event_id],
  orderedTableUUIDs: state.seatingChart.orderedTableUUIDs,
  seatingChart: state.seatingChart.seatingChart,
  seatsByUUID: state.seatingChart.seatsByUUID,
  tableUUIDs: state.seatingChart.orderedTableUUIDs,
  tablesByUUID: state.seatingChart.tablesByUUID,
});

const mapDispatchToProps = dispatch => ({
  onAddTable: (numTables, tables) => dispatch(showModal('NEW_TABLE_MODAL', { numTables, tables }, { size: 'sm' })),
  onDeleteChart: uuid => dispatch(showModal('DELETE_CHART_MODAL', { uuid }, { size: 'md' }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionsBar);



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ActionsBar/ActionsBar.jsx